import EventEmitter from 'vertebrate-event-emitter'

export function eventHandler () {
  let emitter = EventEmitter({})

  return emitter
}



// WEBPACK FOOTER //
// ./src/js/components/event-emitter.js